import { useState, useEffect, useRef } from 'react';

export const useTypingAnimation = (words, typingSpeed = 120, deletingSpeed = 80, pauseTime = 2000) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const currentWord = words[currentWordIndex];
    
    const type = () => {
      if (isDeleting) {
        // Deleting text
        if (currentText.length > 0) {
          setCurrentText(currentWord.substring(0, currentText.length - 1));
          timerRef.current = setTimeout(type, deletingSpeed);
        } else {
          // Finished deleting, move to next word
          setIsDeleting(false);
          setCurrentWordIndex((prev) => (prev + 1) % words.length);
          timerRef.current = setTimeout(type, typingSpeed);
        }
      } else {
        // Typing text
        if (currentText.length < currentWord.length) {
          setCurrentText(currentWord.substring(0, currentText.length + 1));
          timerRef.current = setTimeout(type, typingSpeed);
        } else {
          // Finished typing, pause then start deleting
          setIsDeleting(true);
          timerRef.current = setTimeout(type, pauseTime);
        }
      }
    };

    timerRef.current = setTimeout(type, isDeleting ? deletingSpeed : typingSpeed);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [currentText, isDeleting, currentWordIndex, words, typingSpeed, deletingSpeed, pauseTime]);

  return currentText;
};